export const isAuthenicatedSelector = (state) => state.auth.isAuthenticated;
export const pendingSelector = (state) => state.auth.pending;
export const priceTypesSelector = (state) => state.auth.priceTypeList;
export const userTypesSelector = (state) => state.auth.userTypeList;
export const userDataSelector = (state) => state.auth.userData;
export const userOptionSelector = (state) => state.auth.userOption;
